import {
    Box,
    Flex,
    Heading,
    Separator,
    Collapsible,
} from '@chakra-ui/react'

import { LuChevronDown } from 'react-icons/lu'




export function FoldableSection({ title, defaultOpen = false, children }) {
    return (
        <>
        <Collapsible.Root defaultOpen={defaultOpen}>
            <Collapsible.Trigger asChild>
                <Flex align="center" cursor="pointer" gap={2} py={1} _hover={{ textDecoration: 'underline' }}>
                    <Heading size="md">{title}</Heading>
                    <Collapsible.Context>
                        {({ open }) => (
                            <Box transition="transform 0.2s" transform={open ? 'rotate(-180deg)' : 'rotate(0deg)'}>
                                <LuChevronDown />
                            </Box>
                        )}
                    </Collapsible.Context>
                </Flex>
            </Collapsible.Trigger>
            <Collapsible.Content>
                <Box pt={2}>
                    {children}
                </Box>
            </Collapsible.Content>
        </Collapsible.Root>
        <Separator />
        </>
    )
}